import { render, staticRenderFns } from "./verifyCode.vue?vue&type=template&id=1afdb0d1&"
import script from "./verifyCode.vue?vue&type=script&lang=js&"
export * from "./verifyCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports